import { FunctionComponent } from "react"
import uuid from "react-uuid"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import "./TableRowMenu.css"

interface Props<Args extends unknown[] = []> {
    items: {
        id?: string
        hoverText?: string
        icon: string
        iconColor?: string
        callBack: (...args: Args) => void
        args?: Args
    }[]
    menuId?: string
}

const TableRowMenu: FunctionComponent<Props> = (props) => {

    const { items, menuId } = props

    const tableRowMenuTooltip = (text: string) => (
        <Tooltip id={uuid()}>
            {text}
        </Tooltip>
    )

    return (
        <div
            id={`${menuId ? menuId : uuid()}`}
            className="TableRowMenu"
        >
            {items.map((item, i) => {
                const { icon, iconColor, hoverText, callBack, args } = item
                return (
                    <button
                        key={i}
                        type="button"
                        className="TableRowMenuItem"
                        aria-label={hoverText ? hoverText : icon}
                        onClick={() => callBack(...(args || []))}
                    >
                        {hoverText &&
                            <OverlayTrigger placement="left" overlay={tableRowMenuTooltip(hoverText)}>
                                <span
                                    className="material-icons"
                                    style={{ color: iconColor ? iconColor : "unset" }}
                                >
                                    {icon}
                                </span>
                            </OverlayTrigger>
                        }
                        {!hoverText &&
                            <span
                                className="material-icons"
                                style={{ color: iconColor ? iconColor : "unset" }}
                            >
                                {icon}
                            </span>}
                    </button>
                )
            })}

        </div>
    )
}

export default TableRowMenu